import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Box, Card, Stack } from '@mui/material';
import { Control } from 'react-hook-form';
import { VendorProfile } from '@trnsact/trnsact-shared-types';
import { getAssetUrl } from 'utils/getAssetUrl';
import { DateRangeWithPeriods } from 'components/form/filters/dateRangeWithPeriods/DateRangeWithPeriods';
import { LenderActivityFilterFormValues } from '../../../types';

interface Props {
  control: Control<LenderActivityFilterFormValues>;
  onRangeChange: (range: { endDate: moment.Moment; startDate: moment.Moment }) => Promise<void>;
}

export const LenderActivityFilters = ({ control, onRangeChange }: Props) => {
  const vendorProfile = useSelector<any, VendorProfile>(state => state.vp);
  const logoUrl = getAssetUrl(vendorProfile?.logo ?? '');

  return (
    <Card sx={{ p: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <Box sx={{ width: '50%' }}>
          <DateRangeWithPeriods control={control} nameFrom="from" nameTo="to" onRangeChange={onRangeChange} />
        </Box>

        {logoUrl && (
          <Box
            component="img"
            src={logoUrl}
            alt="Account logo"
            sx={{ /* maxHeight: 48, */ maxWidth: 200, objectFit: 'contain' }}
          />
        )}
      </Stack>
    </Card>
  );
};
